// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"m1-z"};